import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styles from "../../assets/css/OPDCNews.module.css";
import { useTable, useGlobalFilter, useSortBy, useFilters, useExpanded, usePagination } from "react-table";
import { Table, Row, Col, Button } from "reactstrap";
import { DefaultColumnFilter } from "./filters";

const TableContainer = ({
    columns,
    data,
    customPageSize,
    className,
    totalPage,
    currentPage,
    changePage
}) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            defaultColumn: { Filter: DefaultColumnFilter },
            initialState: {
                pageIndex: 0,
                pageSize: customPageSize,
                sortBy: [
                    {
                        desc: true,
                    },
                ],
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination
    );

    const generateSortingIndicator = column => {
        return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : "";
    };

    document.title = "ข่าวสาร | OPDC";

    return (
        <Fragment>
            <div className="table-responsive react-table">
                <Table bordered hover {...getTableProps()} className={`${className}`}>
                    <thead className="table-light table-nowrap">
                        {headerGroups.map(headerGroup => (
                            <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th
                                        key={column.id}
                                        className={column.id === 'number' || column.id === 'option' || column.id === 'updated_date' ? `p-2 py-1 text-nowrap ${styles.min}` : 'p-2 py-1 nowrap'}
                                        {...column.getSortByToggleProps()}
                                    >
                                        {column.render("Header")}
                                        {generateSortingIndicator(column)}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                        {page.map(row => {
                            prepareRow(row);
                            return (
                                <Fragment key={row.getRowProps().key}>
                                    <tr>
                                        {row.cells.map((cell, index) => {
                                            return (
                                                <td key={cell.id} {...cell.getCellProps()} className={index === 0 || index === 4 ? 'text-nowrap text-center align-middle p-2 py-1 ' : 'py-1 p-2 text-nowrap align-middle'} >
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </tbody>
                </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center">
                <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                        <Button
                            className="btn-sm"
                            color="primary"
                            onClick={async () => { await changePage(1) }}
                        >
                            <i className="fa-solid fa-chevrons-left"></i>
                        </Button>
                        <Button
                            className="btn-sm"
                            color="primary"
                            onClick={async () => { await changePage((currentPage - 1) <= 0 ? 1 : (currentPage - 1)) }}
                        >
                            <i className="fa-solid fa-chevron-left"></i>
                        </Button>
                    </div>
                </Col>
                <Col className="col-md-auto ">
                    หน้า{" "}
                    <strong>
                        {currentPage} จาก {totalPage}
                    </strong>
                </Col>
                <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                        <Button
                            className="btn-sm"
                            color="primary"
                            onClick={async () => { await changePage((currentPage + 1) > totalPage ? totalPage : (currentPage + 1)) }}
                        >
                            <i className="fa-solid fa-chevron-right"></i>
                        </Button>
                        <Button
                            className="btn-sm"
                            color="primary"
                            onClick={async () => { await changePage(totalPage) }}
                        >
                            <i className="fa-solid fa-chevrons-right"></i>
                        </Button>
                    </div>
                </Col>
            </Row>
        </Fragment>
    );
};

TableContainer.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
